import ContactCard from '@/components/contact/card/ContactCard.vue'
import ReportsList from '@/components/reports/list/ReportsList.vue'
import ClientContractCard from '@/components/client/contract/card/ClientContractCard.vue'
import HomeCards from '@/components/homecards/HomeCards.vue'
import ClientEditSimple from '@/components/client/edit/simple/ClientEditSimple.vue'

export default {
  components: {
    ContactCard,
    ClientContractCard,
    ReportsList,
    HomeCards,
    ClientEditSimple
  },
  data () {
    return {
      loading: true,
      client: null,
      clientApiId: null
    }
  },
  computed: {
    editBasicData () {
      const clientPerm = this.$session.get('client_permissions');
      if (
        !this.$session.get('isSimUser') && !this.ApiRequest.userHasPermission('edit-clients') &&
        this.clientApiId && clientPerm[this.clientApiId] && clientPerm[this.clientApiId].needUpdate
      ) {
        return true;
      }
      return false;
    },
    clientIsBlocked () {
      return this.BasicHelper.isUserClientBlocked();
    },
    clientManager () {
      if (this.client && this.client.manager_id) {
        return this.$store.getters.getDataFromConfigById('managers', this.client.manager_id);
      }
      return null;
    },
    clientBalance () {
      if (this.client) {
        return parseFloat(this.client.balance) + parseFloat(this.client.balanceAdvanceBill) + parseFloat(this.client.balanceOpenOrders);
      }
      return 0;
    }
  },
  methods: {
    getBasicClientData () {
      if (this.clientApiId) {
        const self = this;
        this.ApiRequest.request('client/single/' + this.clientApiId + '/simple', this.ApiRequest.REQUEST_GET, {}, function (response) {
          if (response.data) {
            self.client = response.data;
          }
          self.loading = false;
        });
      } else {
        this.loading = false;
      }
    },
    viewUnpaidBills (newtab = false) {
      const filters = {
        bill_number: '',
        reportSubCode: [],
        fromDatePeriod: null,
        toDatePeriod: null,
        isPaid: [0],
        onlyMine: [],
        managers: [],
        displayColFilters: true
      };
      this.BasicHelper.updateFilterValues('menu.clients.bills', filters);
      if (newtab) {
        const routeData = this.$router.resolve({ name: 'menu.clients.bills' });
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push('/bills/list');
      }
    }
  },
  mounted () {
    this.clientApiId = this.BasicHelper.getUserClientApiId();
    this.getBasicClientData();
  }
}
